import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import UserManagement from './pages/UserManagement';
import CategoryManagement from './pages/CategoryManagement';
import NovelManagement from './pages/NovelManagement';
import VolumeManagement from './pages/VolumeManagement';
import ChapterManagement from './pages/ChapterManagement';
import ChapterContentEdit from './pages/ChapterContentEdit';
import CarouselManagement from './pages/CarouselManagement';
import EdgettsManagement from './pages/EdgettsManagement';
import SpeakerManagement from './pages/SpeakerManagement';
import TextToJsonTool from './pages/TextToJsonTool';
import OpenAITranslateTool from './pages/OpenAITranslateTool';
import OpenAIPodcastTool from './pages/OpenAIPodcastTool';
import OssMp3Combine from './pages/ossMp3Combine';
import OpenAINotesTool from './pages/OpenAINotesTool';
import BatchPipelineTool from './pages/BatchPipelineTool';
import BatchAllVolumesTool from './pages/BatchAllVolumesTool';
import BatchAllNotesTool from './pages/BatchAllNotesTool';
import BatchTextTool from './pages/BatchTextTool';
import AzureSpeechTool from './pages/AzureSpeechTool';
import NovelStatusTool from './pages/NovelStatusTool';
import VipPlanManagement from './pages/VipPlanManagement';
import PaymentRecords from './pages/PaymentRecords';
import FeedbackManagement from './pages/FeedbackManagement';
import styles from './AdminApp.module.css';

function AdminApp() {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousOverflowY = document.body.style.overflowY;
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'auto';

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.overflowY = previousOverflowY;
    };
  }, []);

  return (
    <div className={styles.adminApp}>
      <AdminLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/categories" element={<CategoryManagement />} />
          <Route path="/carousels" element={<CarouselManagement />} />
          <Route path="/novels" element={<NovelManagement />} />
          <Route path="/volumes" element={<VolumeManagement />} />
          <Route path="/chapters" element={<ChapterManagement />} />
          <Route path="/chapter-content-edit" element={<ChapterContentEdit />} />
          <Route path="/text-to-json" element={<TextToJsonTool />} />
          <Route path="/openai-translate" element={<OpenAITranslateTool />} />
          <Route path="/podcast-generation" element={<OpenAIPodcastTool />} />
          <Route path="/openai-notes" element={<OpenAINotesTool />} />
          <Route path="/oss-mp3-combine" element={<OssMp3Combine />} />
          <Route path="/batch-pipeline" element={<BatchPipelineTool />} />
          <Route path="/batch-all" element={<BatchAllVolumesTool />} />
          <Route path="/batch-all-notes" element={<BatchAllNotesTool />} />
          <Route path="/batch-text" element={<BatchTextTool />} />
          <Route path="/azure-speech" element={<AzureSpeechTool />} />
          <Route path="/novel-status" element={<NovelStatusTool />} />
          <Route path="/edge-tts" element={<EdgettsManagement />} />
          <Route path="/speakers" element={<SpeakerManagement />} />
          <Route path="/vip-plans" element={<VipPlanManagement />} />
          <Route path="/payment-records" element={<PaymentRecords />} />
          <Route path="/feedbacks" element={<FeedbackManagement />} />
        </Routes>
      </AdminLayout>
    </div>
  );
}

export default AdminApp;
